var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RkEcharts',{attrs:{"height":"100%","option":_vm.optionConfigs,"clickEvent":_vm.clickLinks}})}
var staticRenderFns = []

export { render, staticRenderFns }